// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zt-K","colMin":"styles_colMin__3GTLs"};